import React from 'react'
import Button from './Button';

// const List=["All","Live",]

const ButtonList = () => {
  return (
    <div className='flex'>
      <Button name="All"/>
      <Button name="Gaming"/>
      <Button name="Songs"/>
      <Button name="Live"/>
      <Button name="Cricket"/>
      <Button name="News"/>
      <Button name="Cooking"/>
      <Button name="Live"/>
      <Button name="Cricket"/>
      <Button name="News"/>
      <Button name="Cooking"/>
      <Button name="Cricket"/>
      
    </div>
  )
}

export default ButtonList;